import { pgTable, text, timestamp, integer, varchar, index, uniqueIndex, foreignKey } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { adminUser } from './admin';
import { mcpTokenKind } from './enums';

/**
 * OAuth-клиенты MCP (Dynamic Client Registration, RFC 7591).
 * id — публичный client_id, секретов нет (public client + PKCE).
 */
export const mcpOAuthClient = pgTable('McpOAuthClient', {
  id: varchar({ length: 64 }).primaryKey(),
  name: varchar({ length: 255 }).notNull(),
  redirectUris: text().array().notNull(),
  createdByIp: varchar({ length: 64 }),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  revokedAt: timestamp({ precision: 3, mode: 'date' }),
});

/**
 * Токены доступа MCP. Хранится только sha256 от токена.
 * parentId связывает цепочку OAuth refresh-ротации (повторное использование → отзыв цепочки).
 */
export const mcpToken = pgTable('McpToken', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  adminUserId: integer().notNull(),
  name: varchar({ length: 255 }).notNull(),
  tokenHash: varchar({ length: 64 }).notNull(),
  kind: mcpTokenKind().notNull(),
  scopes: text().array().notNull(),
  clientId: varchar({ length: 64 }),
  familyId: varchar({ length: 64 }),
  lastUsedAt: timestamp({ precision: 3, mode: 'date' }),
  expiresAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
  revokedAt: timestamp({ precision: 3, mode: 'date' }),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  uniqueIndex('McpToken_tokenHash_key').using('btree', table.tokenHash.asc().nullsLast()),
  index('McpToken_adminUserId_idx').using('btree', table.adminUserId.asc().nullsLast()),
  index('McpToken_familyId_idx').using('btree', table.familyId.asc().nullsLast()),
  foreignKey({
    columns: [table.adminUserId],
    foreignColumns: [adminUser.id],
    name: 'McpToken_adminUserId_fkey',
  }).onUpdate('cascade').onDelete('cascade'),
  foreignKey({
    columns: [table.clientId],
    foreignColumns: [mcpOAuthClient.id],
    name: 'McpToken_clientId_fkey',
  }).onUpdate('cascade').onDelete('cascade'),
]);

/** Журнал вызовов инструментов MCP. */
export const mcpAuditLog = pgTable('McpAuditLog', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  tokenId: integer(),
  adminUserId: integer(),
  toolName: varchar({ length: 128 }).notNull(),
  method: varchar({ length: 10 }),
  path: text(),
  argsHash: varchar({ length: 64 }),
  status: integer().notNull(),
  durationMs: integer().notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  index('McpAuditLog_createdAt_idx').using('btree', table.createdAt.asc().nullsLast()),
  index('McpAuditLog_adminUserId_idx').using('btree', table.adminUserId.asc().nullsLast()),
  foreignKey({
    columns: [table.tokenId],
    foreignColumns: [mcpToken.id],
    name: 'McpAuditLog_tokenId_fkey',
  }).onUpdate('cascade').onDelete('set null'),
  foreignKey({
    columns: [table.adminUserId],
    foreignColumns: [adminUser.id],
    name: 'McpAuditLog_adminUserId_fkey',
  }).onUpdate('cascade').onDelete('set null'),
]);
